import React, { FunctionComponent, useEffect, useState } from 'react';
import css from './GameSelector.module.less';
import componentContent from './GameSelector.content.json';
import useTranslate from '@hooks/useTranslate';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { useDebounce } from 'use-debounce/lib';
import gamesSelector, { getGameById, getList } from '@stores/gamesSelector';
import { LoadingOutlined } from '@ant-design/icons';
import { useStore } from 'effector-react';
import GameCard from '../GameCard';

type GameSelectorProps = SelectProps<any>;

const GameSelector: FunctionComponent<GameSelectorProps> = ({ ...rest }) => {
  const content = useTranslate(componentContent);
  const [gameSearchText, setGameSearchText] = useState<string | undefined>(undefined);
  const [debouncedGameSearchText] = useDebounce(gameSearchText, 500);
  const gameId = rest.value;

  const { list: gameList, preloaders: gamePreloaders } = useStore(gamesSelector);

  const gameInputSuffix = gamePreloaders.getList ? <LoadingOutlined /> : <span />;

  // eslint-disable-next-line
  const selectedGame = gameList.find((g) => g.id == gameId);

  useEffect(() => {
    if (debouncedGameSearchText) {
      getList(debouncedGameSearchText);
    }
  }, [debouncedGameSearchText]);

  useEffect(() => {
    // eslint-disable-next-line
    const game = gameList.find((game) => game.id == gameId);
    if (!game && gameId) {
      getGameById(gameId);
    }
    // eslint-disable-next-line
  }, [gameId]);

  return (
    <div>
      <Select
        {...rest}
        onSearch={setGameSearchText}
        searchValue={gameSearchText}
        showSearch
        filterOption={false}
        notFoundContent={null}
        suffixIcon={gameInputSuffix}
        allowClear
        placeholder={content.gamePlaceholder}
      >
        {gameList.map((game) => (
          <Select.Option
            value={`${game.id}`}
            key={game.id}
          >
            {game.name}
          </Select.Option>
        ))}
      </Select>
      <div className={css.gameCard}>
        <GameCard
          mode='row'
          game={selectedGame}
        />
      </div>
    </div>
  );
};

export default GameSelector;
